import React, { useState } from 'react'
import { firestore } from '../../firebase';
import SelectRegionHandler from './SelectRegionHandler';

function SearchBolig() {

    const [region, setRegion] = useState()
    const [adresse, setAdresse] = useState("");
    const [str, setStr] = useState(100);

    const [soverom, setSoverom] = useState(1);
    const [bad, setBad] = useState(1);
    const [tomt, setTomt] = useState(0);
    const [transport, setTransport] = useState(30);
    const [parkering, setParkering] = useState(1);
    const [etasje, setEtasje] = useState(1);
    const [alder, setAlder] = useState(20);
    const [pris, setPris] = useState(2500000);

    const [strandlinje, setStrandlinje] = useState(false);

    const [kveldssol, setKveldssol] = useState(1);

    const [error, setError] = useState("");

    const [calculatedPrice, setCalculatedPrice] = useState(0);

    async function searchHandler(e) {
        e.preventDefault();
        const calculatedPrice = searchCalculator()
        try {

            
            console.log(calculatedPrice)
            setCalculatedPrice(calculatedPrice)

            const searchRef = firestore.collection("prissok");
            const dateSearch = new Date().toISOString();
            const data = {
                alder: +alder,
                adresse,
                ant_bad: +bad,
                ant_kvm: +str,
                etasje: +etasje,
                date_search: dateSearch,
                offentlig_transport: +transport,
                garasjeplasser: +parkering,
                pris: +pris,
                type: "advanced"
            }
            searchRef.add(data);
        } catch (error) {
            setError("Kunne ikke legge til søk");
        }
    }

    function searchCalculator() {

        const basePrice = str * (+region)

        // Modifikatorer
        let alderModifikator = 1;
        const badModifikator = 0.04;
        const etasjeModifikator = 0.001;
        

        let tomtVerdi, garasjeVerdi, transportVerdi, alderVerdi = 0, strandlinjeVerdi, kveldssolVerdi, transportModifikator, soveromModifikator;

        if (tomt > 1000) {
            tomtVerdi = 3000000;
        } else if (tomt > 500) {
            tomtVerdi = 1500000;
        } else {
            tomtVerdi = 0;
        }

        if (transport <= 10) {
            transportModifikator = 0.01;
        } else if (transport > 10 && transport < 30) {
            transportModifikator = 0.005;
        } else {
            transportModifikator = 0;
        }

        transportVerdi = basePrice * transportModifikator;
        console.log(transportVerdi, "TRANSPORTVERDI")

        if (alder < 5) {
            alderVerdi = 200000
        } else if (alder < 15) {
            alderVerdi = 100000
        } else if (alder >= 15 && alder < 30) {
            alderVerdi = 50000
        } else {
            alderVerdi = 0;
        }

        if (strandlinje) {
            strandlinjeVerdi = 200000; // 200 000 * (basePrice / modifier)
        } else {
            strandlinjeVerdi = 0
        }

        if (kveldssol === "2") {
            kveldssolVerdi = 500000;
        } else if (kveldssol === "1") {
            kveldssolVerdi = 200000;
        } else {
            kveldssolVerdi = 0;
        }

        if (parkering > 2) {
            garasjeVerdi = 350000;
        } else if (parkering === 2) {
            garasjeVerdi = 300000;
        } else if (parkering === 1) {
            garasjeVerdi = 200000;
        } else {
            garasjeVerdi = 0;
        }

        // Based on region (Postadresse / bydel)

        console.log(tomtVerdi, "TOMT", transportVerdi, "TRANSPORT", alderVerdi, "ALDER", strandlinjeVerdi, "STRAND", kveldssolVerdi, "KVELDSSOL", garasjeVerdi, "GARASJE", basePrice, "STR PRICE", region, "REGION")

        const strPrice = basePrice;
        const totalModifikator = alderModifikator + etasjeModifikator + badModifikator + soveromModifikator + transportModifikator;
        const price = tomtVerdi + transportVerdi + alderVerdi + strandlinjeVerdi + kveldssolVerdi + garasjeVerdi + strPrice;

        const calculatedPrice = price //* totalModifikator;

        return calculatedPrice;

    }

    return (
        <div>
            <div>
                {calculatedPrice > 0 && <h2 className="text-center font-weight-bold text-danger">{calculatedPrice}</h2>}
            </div>
            <form onSubmit={searchHandler}>

                <SelectRegionHandler region={region} setRegion={setRegion} />

                <label>Adresse</label>
                <input className="form-control mb-2" placeholder="Adresse" value={adresse} onChange={e => setAdresse(e.target.value)} />

                <label>Listepris ({pris} kr)</label>
                <input type="range" className="form-control mb-2" step="10000" max="15000000" value={pris} onChange={e => setPris(e.target.value)} />

                <label>Størrelse ({str} kvm)</label>
                <input type="range" className="form-control mb-2" max="1000" step="1" value={str} onChange={e => setStr(e.target.value)} />

                <label>Tomtestørrelse ({tomt} kvm)</label>
                <input type="range" className="form-control mb-2" max="10000" step="1" value={tomt} onChange={e => setTomt(e.target.value)} />

                <label>Antall bad</label>
                <input type="number" className="form-control mb-2" value={bad} onChange={e => setBad(e.target.value)} />

                <label>Antall soverom</label>
                <input type="number" className="form-control mb-2" value={soverom} onChange={e => setSoverom(e.target.value)} />

                <label>Gangavstand offentlig transport i minutter ({transport} minutter)</label>
                <input type="range" className="form-control mb-2" placeholder="Avstand offentlig transport" value={transport} onChange={e => setTransport(e.target.value)} />

                <label>Antall parkeringsplasser</label>
                <input type="number" className="form-control mb-2" placeholder="Parkeringsplasser" value={parkering} onChange={e => setParkering(e.target.value)} />

                <label>Etasje</label>
                <input type="number" className="form-control mb-2" placeholder="Etasje" value={etasje} onChange={e => setEtasje(e.target.value)} />

                <label>Alder bolig</label>
                <select className="browser-default custom-select mb-3" onChange={e => setAlder(e.target.value)}>
                    <option value="1">Ny (mindre enn 5 år)</option>
                    <option value="5">5-10 år</option>
                    <option value="10">10-20 år</option>
                    <option value="20">20-30</option>
                    <option value="30">30-40</option>
                    <option value="40">40 eller eldre</option>
                </select>

                <label>Kveldssol</label>
                <select className="browser-default custom-select mb-3" onChange={e => setKveldssol(e.target.value)}>
                    <option value="0">Ingen kveldssol</option>
                    <option value="1">Noe kveldssol</option>
                    <option value="2">Mye kveldssol</option>
                </select>

                <label>Strandlinje</label>
                <select className="browser-default custom-select mb-2" onChange={e => setStrandlinje(e.target.value)}>
                    <option value="false">Nei</option>
                    <option value="true">Ja</option>
                </select>

                {error && <div className="alert alert-danger">{error}</div>}
                <button className="btn btn-success btn-block">Søk</button>
            </form>
        </div>
    )

}
export default SearchBolig